/**
 * @namespace Voting
 * @aka S3.Voting
 */
S3.Voting = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'voting';
  var DATA_KEY = 'swr3.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'form.form-voting[data-spy=validate]'
  };

  var Default = {
    maxAnswers: 1,
    resultUrl: null
  };

  var DefaultType = {
    maxAnswers: '(null|number)',
    resultUrl: '(null|string)',
    playMode: 'string'
  }

  var Templates = {
    VOTING_RESULT: '<span class="graph">' +
      '<span class="voting-graph" style="width: {value}"></span>' +
      '<span class="voting-value">{value}</span>' +
      '</span>',
    USER_ERROR: '<div class="alert alert-danger"><p>{meldung} Du darfst maximal {text} auswählen.</p></div>',
    USER_ERROR_MIN: 'Bitte wähle mindestens eine Antwort aus.',
    USER_ERROR_MAX: 'Du hast zu viele Antworten ausgewählt.'
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Voting = function () {

    function Voting(element, config) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self.config = self._getConfig(config);

      // Erst mal aufräumen
      self.$element.find('input[required]').removeAttr('required');
      self.$element.find('[data-required=true]').removeAttr('data-required');

      self._bindEvents();

      if ('voting-result' === self.config.playMode) {
        self._loadResult();
      }
    }

    Voting.prototype._bindEvents = function _bindEvents() {
      var self = this;

      // Ergebnis vorab prüfen
      self.$element.on('submit' + EVENT_KEY, function (event) {
        self.$element.find('.alert').remove();

        var formData = new FormData(event.target);
        var countAnswers = Array.from(formData.entries()).length;
        if (0 === countAnswers || countAnswers > self.config.maxAnswers) {
          event.preventDefault();
          event.stopPropagation();

          // Fehlermeldung anzeigen
          self.$element.find('.voting-question header').append(S3.Util.template(Templates.USER_ERROR, {
            meldung: 0 === countAnswers ? Templates.USER_ERROR_MIN : Templates.USER_ERROR_MAX,
            text: self.config.maxAnswers + ' Antwort' + (1 < self.config.maxAnswers ? 'en' : '')
          }));
          self.element.scrollIntoView({
            behavior: 'auto',
            block: 'start',
            inline: 'start'
          });

          return false;
        }
      });
    }

    Voting.prototype._loadResult = function _loadResult() {
      var self = this;

      /*
       * Fetch API
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
       */
      var apiRequestUrl = new URL(self.config.resultUrl);

      fetch(apiRequestUrl.toString(), {
        cache: 'no-cache',
        credentials: 'omit',
        headers: {
          'Accept': 'application/json, */*; q=0.01'
        },
        method: 'GET'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Request rejected with status ' + response.status + ' and message ' + response.statusText);
        }
        return response.json();
      }).then(function (data) {
        if (0 === Object.keys(data).length) {
          return
        }

        Object.keys(data).forEach(function (key) {
          self.$element.find('input[value="' + key + '"]').closest('.checkbox,.radio').find('.voting-question-detail').append(S3.Util.template(Templates.VOTING_RESULT, {
            value: data[key]
          }))
        })
      }).catch(function () {
      });
    }

    // private
    Voting.prototype._getConfig = function _getConfig(config) {
      config = extend({}, Default, config);

      S3.Util.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // public
    Voting.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      // clean up your mess!
      this.$element = null;
      this.element = null;
    };

    /**
     * @static
     */
    Voting._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var element = this;
        var data = $(element).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : S3.Util._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Voting(element, _config);
          $(element).data(DATA_KEY, data);
        }
      });
    };

    return Voting;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    Voting._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      Voting._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Voting._jQueryInterface;
  $.fn[NAME].Constructor = Voting;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Voting._jQueryInterface;
  };

  return Voting;

}(window.jQuery);
